import { render, staticRenderFns } from "./HistoriesTab.vue?vue&type=template&id=19b90ad5&"
import script from "./HistoriesTab.vue?vue&type=script&lang=ts&"
export * from "./HistoriesTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports